import { render, staticRenderFns } from "./MeituanProductMapping.vue?vue&type=template&id=0df04a50&scoped=true"
import script from "./MeituanProductMapping.vue?vue&type=script&lang=js"
export * from "./MeituanProductMapping.vue?vue&type=script&lang=js"
import style0 from "./MeituanProductMapping.vue?vue&type=style&index=0&id=0df04a50&prod&lang=less"
import style1 from "./MeituanProductMapping.vue?vue&type=style&index=1&id=0df04a50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df04a50",
  null
  
)

export default component.exports